import { render, staticRenderFns } from "./dlocal.vue?vue&type=template&id=0846ec02&scoped=true"
import script from "./dlocal.vue?vue&type=script&lang=js"
export * from "./dlocal.vue?vue&type=script&lang=js"
import style0 from "./dlocal.vue?vue&type=style&index=0&id=0846ec02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0846ec02",
  null
  
)

export default component.exports